// extracted by mini-css-extract-plugin
export default {"mod":"Module_mod__mM3mq","desc":"Module_desc__cYGfS","carousel":"Module_carousel__Kgw0-","active":"Module_active__rBebW","hint":"Module_hint__hwQNj"};